import { Col, Header } from 'components';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';


const Container = styled.div``;

/*
  IMPORTANT!: This file is temporary.
*/
const UserInit = ({ welcomeVisible }) => {
  return (
    <Col>
      <Header />

      <Container>
        <Outlet />
      </Container>
    </Col>
  );
};

export default UserInit;
